/* Rockstar Garage storefront enhancements: no runtime dependencies. */
(function () {
  'use strict';
  if (window.rsgStorefrontLoaded) return;
  window.rsgStorefrontLoaded = true;

  var modes = ['white', 'light-grey', 'dark-grey', 'black'];
  function applyMode(mode, persist) {
    if (modes.indexOf(mode) === -1) mode = 'white';
    var root = document.documentElement;
    var changed = root.dataset.rsgMode !== mode;
    if (changed) root.classList.add('rsg-mode-changing');
    root.dataset.rsgMode = mode;
    if (changed) {
      void root.offsetWidth; // Commit both foreground and background before transitions resume.
      requestAnimationFrame(function () { root.classList.remove('rsg-mode-changing'); });
    }
    document.querySelectorAll('select[name="rsg-appearance"]').forEach(function (select) { select.value = mode; });
    if (persist) {
      try { localStorage.setItem('rsg:appearance', mode); } catch (error) {}
    }
  }
  document.addEventListener('change', function (event) {
    if (event.target.matches('[name="rsg-appearance"]')) applyMode(event.target.value, true);
  });
  window.addEventListener('storage', function (event) {
    if (event.key === 'rsg:appearance') applyMode(event.newValue, false);
  });

  var requests = new Map();
  var queue = [];
  var active = 0;

  function pump() {
    while (active < 4 && queue.length) {
      active += 1;
      var job = queue.shift();
      job().finally(function () { active -= 1; pump(); });
    }
  }

  function countFor(base, tags) {
    var url = new URL(base.replace(/\/$/, '') + '/' + tags, window.location.origin);
    url.searchParams.set('view', 'count');
    var key = url.pathname;
    if (requests.has(key)) return requests.get(key);
    var storageKey = 'rsg:category:v1:' + key;
    try {
      var cached = JSON.parse(sessionStorage.getItem(storageKey));
      if (cached && Number.isSafeInteger(cached.count) && cached.count >= 0 &&
          Number.isFinite(cached.at) && Date.now() >= cached.at && Date.now() - cached.at < 300000) {
        return Promise.resolve(cached.count);
      }
    } catch (error) { /* Storage may be disabled; filtering must still work. */ }
    var pending = new Promise(function (resolve, reject) {
      queue.push(function () {
        return fetch(url.href, { credentials: 'same-origin' })
          .then(function (response) {
            if (!response.ok) throw new Error('Count unavailable');
            return response.text();
          })
          .then(function (text) {
            var value = Number(text.trim());
            if (!/^\d+$/.test(text.trim()) || !Number.isSafeInteger(value)) throw new Error('Invalid count');
            try { sessionStorage.setItem(storageKey, JSON.stringify({ count: value, at: Date.now() })); } catch (error) {}
            resolve(value);
          }).catch(reject);
      });
    });
    requests.set(key, pending);
    pump();
    return pending;
  }

  function initCategories(root) {
    if (root.dataset.rsgReady) return;
    root.dataset.rsgReady = 'true';
    var tags = root.dataset.tagPath;
    if (!tags) { root.dataset.rsgState = 'ready'; return; }
    var status = root.querySelector('[data-rsg-status]');
    var rows = Array.from(root.querySelectorAll('[data-rsg-category]'));
    var failed = false;
    status.textContent = 'Finding categories for your vehicle…';
    status.hidden = false;
    root.setAttribute('aria-busy', 'true');
    rows.forEach(function (row) { row.hidden = true; });
    Promise.all(rows.map(function (row) {
      var badge = row.querySelector('[data-rsg-count]');
      return countFor(row.dataset.rsgUrl, tags).then(function (count) {
        row.hidden = count === 0;
        row.dataset.rsgState = 'verified';
        row.dataset.rsgCount = String(count);
        if (badge) { badge.textContent = String(count); badge.hidden = count === 0; }
      }).catch(function () {
        failed = true;
        row.hidden = false; // Unknown is not zero: never discard a category on a failed lookup.
        row.dataset.rsgState = 'unknown';
        if (badge) badge.hidden = true;
      });
    })).then(function () {
      root.querySelectorAll('[data-rsg-group]').forEach(function (group) {
        group.hidden = !Array.from(group.querySelectorAll('[data-rsg-category]')).some(function (row) { return !row.hidden; });
      });
      var any = rows.some(function (row) { return !row.hidden; });
      status.textContent = failed ? 'Some counts are unavailable. Category links remain available.' : (any ? '' : 'No categories match this vehicle.');
      status.hidden = !status.textContent;
      root.setAttribute('aria-busy', 'false');
      root.dataset.rsgState = failed ? 'partial' : 'ready';
    });
  }

  function initMenus() {
    document.querySelectorAll('[data-rsg-parts-menu]').forEach(function (menu) {
      if (menu.dataset.rsgReady) return;
      menu.dataset.rsgReady = 'true';
      var desktop = window.matchMedia('(min-width: 992px)');
      function resize() { menu.open = desktop.matches; }
      desktop.addEventListener('change', resize);
      resize();
      menu.querySelectorAll('[data-rsg-group]').forEach(function (group) {
        group.addEventListener('toggle', function () {
          if (!group.open) return;
          menu.querySelectorAll('[data-rsg-group]').forEach(function (other) { if (other !== group) other.open = false; });
        });
      });
    });
  }
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = event.target.closest('[data-rsg-group][open], [data-rsg-parts-menu][open]');
    if (open && open.matches('[data-rsg-parts-menu]') && window.matchMedia('(min-width: 992px)').matches) return;
    if (open) { open.open = false; open.querySelector('summary').focus(); event.preventDefault(); }
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('.rsg-categories--nav [data-rsg-group][open]').forEach(function (group) {
      if (!group.contains(event.target)) group.open = false;
    });
  });

  var quickviewSizingBound = false;
  function initQuickviewSizing() {
    if (quickviewSizingBound || !window.jQuery) return;
    quickviewSizingBound = true;
    function resizeQuickview() {
      requestAnimationFrame(function () {
        var gallery = document.getElementById('qv-product-images');
        // Slick may initialize while the modal is hidden and measure a zero-width slide.
        if (gallery && gallery.clientWidth > 0 && gallery.slick && !gallery.slick.unslicked) {
          gallery.slick.setPosition();
        }
      });
    }
    window.jQuery(document).on('shown.bs.modal.rsgPhotos', '#jsQuickview', resizeQuickview)
      .on('init.rsgPhotos', '#qv-product-images', resizeQuickview);
  }
  window.addEventListener('load', initQuickviewSizing);

  function init() {
    initQuickviewSizing();
    applyMode(document.documentElement.dataset.rsgMode, false);
    initMenus();
    document.querySelectorAll('[data-rsg-categories]').forEach(initCategories);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
